export const syncScrollLeft = (source, target) => {
  if (!source || !target) return false;
  if (source.scrollLeft === target.scrollLeft) return false;
  target.scrollLeft = source.scrollLeft;
  return true;
};

export const getTopScrollbarState = (scroller) => {
  const scrollWidth = Number(scroller?.scrollWidth) || 0;
  const clientWidth = Number(scroller?.clientWidth) || 0;
  const offsetWidth = Number(scroller?.offsetWidth) || clientWidth;
  const gutter = Math.max(0, offsetWidth - clientWidth);
  return {
    spacerWidth: scrollWidth + gutter,
    visible: scrollWidth > clientWidth,
  };
};

export const bindScrollSync = (bottom, top) => {
  const onBottom = () => syncScrollLeft(bottom, top);
  const onTop = () => syncScrollLeft(top, bottom);
  bottom.addEventListener("scroll", onBottom);
  top.addEventListener("scroll", onTop);
  return () => {
    bottom.removeEventListener("scroll", onBottom);
    top.removeEventListener("scroll", onTop);
  };
};
